export const AUTH_STORAGE_NAME = 'userAuth';
export const ACCESS_TOKEN_NAME = 'accessToken';

export const MONTH = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Setiembre',
  'Octubre',
  'Noviembre',
  'Diciembre'
];

// dummy buyers used by the box office when there is no real buyer data
export const COURTESY_EMAIL = 'entradascortesia@gmail.com';
export const EXTERNAL_USER_EMAIL = 'externo@joinnus.com';
// payment method sent when the sale is a courtesy (no charge)
export const COURTESY_PAYMENT_METHOD = 'free-boxoffice';

export const PAY_METHODS = ['EFECTIVO', 'POS', 'MASTERCARD', 'TRANSFERENCIA', 'QRVISA'];
export const CARDS = ['visa', 'mastercard', 'transferencia'];
export const CARD_TYPES = ['VISA', 'MASTERCARD', 'DINNERS', 'AMEX'];
export const BANKS = ['BCP', 'BBVA', 'INTERBANK', 'SCOTIABANK', 'OTROS'];
export const DETAIL_PAYMENT = ['izipay', 'niubiz']

export default {};
